import React from "react";
import s from "./style.module.css";
import Container from "../Container";
import { ReactComponent as Logo } from "../../assets/logos/Totaljobs-totem.svg";
import Social from "../Social";
import Link from "../../typography/Link";

const Footer = props => {
  return (
    <footer>
      <Container>
        <div className={s.textAndSocialContainer}>
          <div className={s.footerTextContainer}>
            <small>Survey of XXXX UK workers in MONTH YEAR.</small>
            <br />
            <small>Research produced and analysed by Totaljobs</small>
            <br />
            <small>
              Created in collaboration with{" "}
              <Link
                href="https://beyondwordsstudio.com/"
                underline
                target="_blank"
                rel="noopener nofollow"
              >
                Beyond Words Studio.
              </Link>
            </small>
          </div>
          <div className={s.socialContainer}>
            <Social />
            <Logo />
          </div>
        </div>
        <div className={s.navContainer}>
          <Link
            href="https://www.totaljobs.com/about/about-us"
            color="Green"
            rel="nofollow"
          >
            About&nbsp;Us
          </Link>
          <Link
            href="https://www.totaljobs.com/about/contact-us"
            color="Green"
            rel="nofollow"
          >
            Contact&nbsp;Us
          </Link>
          <Link
            href="https://www.totaljobs.com/about/privacy-policy"
            color="Green"
            rel="nofollow"
          >
            Privacy&nbsp;Policy
          </Link>
          <Link
            href="https://www.totaljobs.com/about/terms-and-conditions"
            color="Green"
            rel="nofollow"
          >
            Terms&nbsp;and&nbsp;Conditions
          </Link>
          <Link
            href="https://www.totaljobs.com/about/cookies"
            color="Green"
            rel="nofollow"
          >
            Cookies
          </Link>
        </div>
        <small />
      </Container>
    </footer>
  );
};

export default Footer;
